import { getRecoil } from "recoil-nexus";
import { ProductTypeEnum } from "src/constants/enums/productType";
import upperDataStore from "src/stores/upperData";
import TerminalSwarmActions from "./swarmActions/terminal";
import CashierSwarmActions from "./swarmActions/cashier";
import { BetTypeEnum } from "src/constants/enums/betType";

const actionMap = {
	[ProductTypeEnum.Terminal]: TerminalSwarmActions.requestMaxStake,
	[ProductTypeEnum.Cashier]: CashierSwarmActions.requestMaxStake,
};

export const getMaxStake = async (eventIds: number[], betType: BetTypeEnum, systemMinCount?:number) => {
	const { config } = getRecoil(upperDataStore);
	const action = actionMap[ProductTypeEnum[config.productType]];

	return await action(eventIds, betType, systemMinCount);
};
